module.exports = __webpack_public_path__ + "img/HeroDemos-mob.8f44461f.webp";